import React from 'react'
import { initializeApollo } from '@gql/client'
import { AllMagazineDocument, PaginaDocument, AllCategorieMagazineDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { MagazineHubTemplate } from '@components/templates'

const MagazineHub = ({ pagina, categorie, magazine }) => (
  <MagazineHubTemplate pagina={pagina} categorie={categorie} news={magazine} />
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'magazine', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { allMagazine },
    } = await client.query({
      query: AllMagazineDocument,
    })

    const {
      data: { allCategorieMagazine },
    } = await client.query({
      query: AllCategorieMagazineDocument,
    })

    return {
      props: { pagina, categorie: allCategorieMagazine, magazine: allMagazine },
      revalidate: 60 * 20,
    }
  },
  '/magazine'
)

export default MagazineHub
